// ============================================================================
// THUMBNAIL CACHE
// ============================================================================
// In-memory cache for rendered thumbnail images
// Key: URL or cacheKey, Value: { dataUrl, width, height, timestamp }

const thumbnailCache = new Map();
const MAX_CACHE_SIZE = 100;
const CACHE_TTL = 30 * 60 * 1000; // 30 minutes

/**
 * Get cached thumbnail if available and not expired
 */
export const getCachedThumbnail = (key) => {
  if (!key) return null;

  const cached = thumbnailCache.get(key);
  if (!cached) return null;

  // Check if expired
  if (Date.now() - cached.timestamp > CACHE_TTL) {
    thumbnailCache.delete(key);
    return null;
  }

  return cached;
};

/**
 * Store thumbnail in cache
 */
export const setCachedThumbnail = (key, dataUrl, width, height) => {
  if (!key) return;

  // Evict oldest entries if cache is full
  if (thumbnailCache.size >= MAX_CACHE_SIZE) {
    let oldestKey = null;
    let oldestTime = Infinity;

    for (const [k, v] of thumbnailCache.entries()) {
      if (v.timestamp < oldestTime) {
        oldestTime = v.timestamp;
        oldestKey = k;
      }
    }

    if (oldestKey) {
      thumbnailCache.delete(oldestKey);
    }
  }

  thumbnailCache.set(key, {
    dataUrl,
    width,
    height,
    timestamp: Date.now(),
  });
};

/**
 * Clear all cached thumbnails (useful for logout/cleanup)
 */
export const clearThumbnailCache = () => {
  thumbnailCache.clear();
};

/**
 * Clear specific thumbnail from cache
 */
export const invalidateThumbnail = (key) => {
  thumbnailCache.delete(key);
};
